import React from "react";

export default function DrivingSchoolWhyChoose() {
  const stats = [
    {
      value: "20,000+",
      title: "Happy Students",
      desc: "We have successfully transformed 20,000+ beginners into skilled and confident drivers.",
      icon: "https://cdn-icons-png.flaticon.com/512/4140/4140048.png",
    },
    {
      value: "22",
      title: "Expert Trainers",
      desc: "Get driving training from our team of driving professionals that has 22+ expert male and female trainers.",
      icon: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
    },
    {
      value: "6",
      title: "Training Schools",
      desc: "We have made quality driving training accessible with our widespread network of 6+ Training Schools covering 6 Cities.",
      icon: "https://cdn-icons-png.flaticon.com/512/1828/1828884.png",
    },
  ];

  return (
    <section className="w-full bg-white py-10 sm:py-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        {/* Heading */}
        <div className="mb-10 sm:mb-12">
          <h2 className="text-[#1A2B8F] font-bold text-xl sm:text-2xl md:text-3xl leading-snug">
            Why Choose Maruti Suzuki Driving School?
          </h2>

          <p className="mt-2 text-gray-600 text-sm sm:text-base max-w-2xl leading-relaxed">
            Knowing how to drive a car is no longer a luxury, it&apos;s a
            necessity!
          </p>
        </div>

        {/* Main Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          {/* Left Stats */}
          <div className="space-y-4">
            {stats.map((item, index) => (
              <div
                key={index}
                className="flex gap-4 items-start p-5 rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-md transition"
              >
                {/* Icon */}
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#1A2B8F]/5 shrink-0">
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="w-7 h-7 object-contain"
                  />
                </div>

                {/* Content */}
                <div>
                  <h3 className="text-[#1A2B8F] font-extrabold text-2xl sm:text-3xl leading-none">
                    {item.value}
                  </h3>

                  <p className="mt-1 text-[#1A2B8F] font-semibold text-xs sm:text-sm uppercase tracking-wide">
                    {item.title}
                  </p>

                  <p className="mt-2 text-gray-600 text-sm leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Right Side Card */}
          <div className="w-full">
            <div className="rounded-2xl border border-gray-200 bg-gradient-to-br from-[#F6F8FF] to-white shadow-sm p-6 sm:p-8">
              {/* Image */}
              <div className="flex justify-center">
                <img
                  src={require("../../assets/why-chooseImg1.webp")}
                  alt="Driving School"
                  className="w-full max-w-md object-contain"
                />
              </div>

              {/* Text */}
              <div className="mt-6 text-center lg:text-left">
                <h3 className="text-[#1A2B8F] font-bold text-base sm:text-xl">
                  Learn Theoretically. Apply Practically.
                </h3>

                <p className="mt-2 text-gray-600 text-sm sm:text-base leading-relaxed">
                  Perfection comes with seamless integration of learning and
                  application! Become a confident driver by getting theoretical
                  and practical training at Maruti Suzuki Driving School.
                </p>

                {/* Button */}
                <div className="mt-5 flex justify-center lg:justify-start">
                  <button className="bg-[#1A2B8F] text-white px-7 py-2.5 rounded-md text-sm font-semibold hover:bg-[#122070] transition shadow-sm hover:shadow-md">
                    VIEW ALL
                  </button>
                </div>
              </div>
            </div>

            {/* Note */}
            <p className="text-xs text-gray-500 mt-3">
              *Training availability may vary by city and driving school.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
